import gql from 'graphql-tag';

export default gql`
    query GetLoadAllocationSummary($input: GetLoadAllocationSummaryInput) {
        getLoadAllocationSummary(input: $input) {
            id
            proppantName
            lofaName
            sandPO
            transportationPO
            loadDate
            plannedWeight
            actualWeight
            dispatchedWeight
            remainingWeight
            lofaId
            proppantId
            regionId
            createdLoads
        }
    }
`;
